import { ApiManager } from '../../core/api-manager';
import { DataManager } from '../../core/data-manager';
import { settings } from '../../config/settings';
import { LanguageProvider } from '../../core/language-provider';
import { toast } from 'react-toastify';



export async function preDelete(entity, id) {

    if (entity === "customer_order") {
        let constraints = [{ "fieldName": "idCustomerOrder", type: "value", value: id }]
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var res = await DataManager.searchItems('supplier_order', 1, 100, sorting, '', [], constraints)
        if (res.success === 1) {
            if (res.body.length > 0) {
                toast.error("Attenzione! Non è possibile cancellare questo ordine perché sono già stati creati gli ordini fornitore.",  { theme: 'colored' })
            } else {
                return {
                    success: 1,
                    message: ''
                }
            }
        }
    } else {
        return {
            success: 1,
            message: ''
        }
    }




}